import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

const Left = (props: Props) => (
  <div className="basis-20 md:basis-60">{props.children}</div>
);
const Right = (props: Props) => (
  <div className="flex basis-60 flex-col gap-10 pt-16">{props.children}</div>
);
const Content = (props: Props) => (
  <div className="flex w-full flex-1 flex-col gap-8">{props.children}</div>
);

/** Use this component inside of `<AppLayout.Main>` */
export const SettingsLayout = (props: Props) => (
  <div className="mx-auto flex max-w-7xl flex-col gap-14 px-8 pt-10 pb-24 md:flex-row">
    {props.children}
  </div>
);

export const SettingsLayoutLeft = Left;
export const SettingsLayoutContent = Content;
export const SettingsLayoutRight = Right;

SettingsLayout.Left = Left;
SettingsLayout.Right = Right;
SettingsLayout.Content = Content;
